import * as React from 'react'
import type { SVGProps } from 'react'
import { type Ref, forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSearchLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M17 10.5a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m2 0a8.46 8.46 0 0 1-1.826 5.26l4.533 4.533.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-4.533-4.533A8.46 8.46 0 0 1 10.5 19a8.5 8.5 0 1 1 8.5-8.5'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSearchLine)
export default ForwardRef
